var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isLoading
    ? _c("div", { staticClass: "page-container" }, [
        _c(
          "div",
          { staticClass: "page-form-column" },
          [
            _c(
              "div",
              { staticClass: "back-link-container" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "back-link",
                    attrs: {
                      to: {
                        name: "Order Details",
                        params: { orderId: _vm.$route.params.orderId },
                      },
                    },
                  },
                  [
                    _c("md-icon", [_vm._v("arrow_back")]),
                    _c("span", [_vm._v("Back to Order Details")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "md-card",
              [
                _c("md-card-header", [
                  _c("div", { staticClass: "md-title" }, [
                    _vm._v("Order Information"),
                  ]),
                ]),
                _c("md-card-content", [
                  _c("div", { staticClass: "md-layout md-gutter" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-medium-size-33 md-small-size-100",
                      },
                      [
                        _c(
                          "form-group",
                          {
                            attrs: {
                              name: "orderNumber",
                              label: "Order Number",
                            },
                          },
                          [
                            _c("md-input", {
                              attrs: {
                                value: _vm.orderDetails.orderNumber,
                                disabled: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-medium-size-33 md-small-size-100",
                      },
                      [
                        _c(
                          "form-group",
                          {
                            attrs: {
                              name: "sourceReference",
                              label: "Source Reference",
                            },
                          },
                          [
                            _c("md-input", {
                              model: {
                                value: _vm.orderDetails.sourceReference,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderDetails,
                                    "sourceReference",
                                    $$v
                                  )
                                },
                                expression: "orderDetails.sourceReference",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-medium-size-33 md-small-size-100",
                      },
                      [
                        _c(
                          "form-group",
                          {
                            attrs: {
                              name: "purchaseOrderNumber",
                              label: "Purchase Order Number",
                            },
                          },
                          [
                            _c("md-input", {
                              model: {
                                value: _vm.orderDetails.purchaseOrderNumber,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderDetails,
                                    "purchaseOrderNumber",
                                    $$v
                                  )
                                },
                                expression: "orderDetails.purchaseOrderNumber",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "md-layout md-gutter" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-medium-size-50 md-small-size-100",
                      },
                      [
                        _c(
                          "form-group",
                          {
                            attrs: { name: "teamRegion", label: "Team Region" },
                          },
                          [
                            _c("team-region-options", {
                              attrs: {
                                selected: _vm.orderDetails.teamRegionId,
                              },
                              on: {
                                selectedOption: _vm.handleTeamRegionChanged,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-medium-size-50 md-small-size-100",
                      },
                      [
                        _c(
                          "form-group",
                          {
                            attrs: {
                              name: "handlingMethod",
                              label: "Handling Method",
                            },
                          },
                          [
                            _c("md-input", {
                              attrs: { type: "hidden" },
                              model: {
                                value: _vm.orderDetails.handlingMethod,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderDetails,
                                    "handlingMethod",
                                    $$v
                                  )
                                },
                                expression: "orderDetails.handlingMethod",
                              },
                            }),
                            _c("vue-select", {
                              attrs: {
                                options: _vm.handlingMethodOptions,
                                label: "handling method",
                              },
                              model: {
                                value: _vm.orderDetails.handlingMethod,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderDetails,
                                    "handlingMethod",
                                    $$v
                                  )
                                },
                                expression: "orderDetails.handlingMethod",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "md-layout md-gutter" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-medium-size-50 md-small-size-100",
                      },
                      [
                        _c("CustomerOptions", {
                          attrs: {
                            selected: _vm.orderDetails.customerId,
                            "team-region-id": _vm.orderDetails.teamRegionId,
                          },
                          on: { selectedOption: _vm.handleCustomerChanged },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-medium-size-50 md-small-size-100",
                      },
                      [
                        _c("charging-type-options", {
                          attrs: {
                            "selected-charge-type-id":
                              _vm.orderDetails.rateGroupId,
                          },
                          on: { selectedOption: _vm.handleRateTypeChanged },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "md-card",
              [
                _c("md-card-header", [
                  _c("h3", { staticClass: "md-title" }, [
                    _vm._v("Schedule & Dates"),
                  ]),
                ]),
                _c("md-card-content", [
                  _c("div", { staticClass: "md-layout md-gutter" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-medium-size-50 md-small-size-100",
                      },
                      [
                        _c(
                          "md-datepicker",
                          {
                            attrs: { "md-immediately": "", "md-debounce": 10 },
                            model: {
                              value: _vm.orderDetails.orderDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.orderDetails, "orderDate", $$v)
                              },
                              expression: "orderDetails.orderDate",
                            },
                          },
                          [_c("label", [_vm._v("Order Date")])]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-medium-size-50 md-small-size-100",
                      },
                      [
                        _c(
                          "md-datepicker",
                          {
                            attrs: { "md-immediately": "", "md-debounce": 10 },
                            model: {
                              value: _vm.orderDetails.expectedDeliveryDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.orderDetails,
                                  "expectedDeliveryDate",
                                  $$v
                                )
                              },
                              expression: "orderDetails.expectedDeliveryDate",
                            },
                          },
                          [_c("label", [_vm._v("Expected Delivery Date")])]
                        ),
                        _vm.hasAssignedDropStop
                          ? _c(
                              "div",
                              { staticClass: "md-helper-text-warning" },
                              [
                                _vm._v(
                                  "\n                            This delivery is already assigned to a team member. Updating the expected delivery date will impact the team member's trip.\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "md-layout md-gutter" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-medium-size-50 md-small-size-100",
                      },
                      [
                        _c(
                          "md-datepicker",
                          {
                            attrs: { "md-immediately": "", "md-debounce": 10 },
                            model: {
                              value: _vm.orderDetails.readyPickupAvailableDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.orderDetails,
                                  "readyPickupAvailableDate",
                                  $$v
                                )
                              },
                              expression:
                                "orderDetails.readyPickupAvailableDate",
                            },
                          },
                          [_c("label", [_vm._v("Ready Pickup Date")])]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-medium-size-50 md-small-size-100",
                      },
                      [
                        _c(
                          "md-datepicker",
                          {
                            attrs: { "md-immediately": "", "md-debounce": 10 },
                            model: {
                              value:
                                _vm.orderDetails.readyDeliveryAvailableDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.orderDetails,
                                  "readyDeliveryAvailableDate",
                                  $$v
                                )
                              },
                              expression:
                                "orderDetails.readyDeliveryAvailableDate",
                            },
                          },
                          [_c("label", [_vm._v("Ready Delivery Date")])]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "md-card",
              [
                _c(
                  "md-card-header",
                  [
                    _c("h3", { staticClass: "md-title" }, [
                      _vm._v(
                        "\n                    Pickup Address\n                    "
                      ),
                      _c("span", { staticClass: "optional-label" }, [
                        _vm._v("(Optional)"),
                      ]),
                    ]),
                    _c(
                      "md-checkbox",
                      {
                        staticClass: "pickup-checkbox",
                        model: {
                          value: _vm.hasPickupAddress,
                          callback: function ($$v) {
                            _vm.hasPickupAddress = $$v
                          },
                          expression: "hasPickupAddress",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    Enable pickup address\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm.hasPickupAddress
                  ? _c("md-card-content", [
                      _c("div", { staticClass: "md-layout md-gutter" }, [
                        _c(
                          "div",
                          { staticClass: "md-layout-item" },
                          [
                            _c("google-autocomplete", {
                              attrs: {
                                label: "Pickup Address",
                                id: "pickupAddress",
                                classname: "form-control autocomplete-input",
                                placeholder: "",
                                "should-focus": false,
                              },
                              on: {
                                placechanged: _vm.handlePickupAddressChange,
                              },
                              model: {
                                value: _vm.orderDetails.pickupAddress,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderDetails,
                                    "pickupAddress",
                                    $$v
                                  )
                                },
                                expression: "orderDetails.pickupAddress",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "md-layout md-gutter" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-medium-size-33 md-small-size-100",
                          },
                          [
                            _c(
                              "form-group",
                              {
                                attrs: {
                                  name: "pickupContactName",
                                  label: "Pickup Contact Name",
                                },
                              },
                              [
                                _c("md-input", {
                                  model: {
                                    value: _vm.orderDetails.pickupContact.name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.orderDetails.pickupContact,
                                        "name",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "orderDetails.pickupContact.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-medium-size-33 md-small-size-100",
                          },
                          [
                            _c(
                              "form-group",
                              {
                                attrs: {
                                  name: "pickupContactPhone",
                                  label: "Pickup Contact Phone",
                                },
                              },
                              [
                                _c("md-input", {
                                  model: {
                                    value: _vm.orderDetails.pickupContact.phone,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.orderDetails.pickupContact,
                                        "phone",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "orderDetails.pickupContact.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-medium-size-33 md-small-size-100",
                          },
                          [
                            _c(
                              "form-group",
                              {
                                attrs: {
                                  name: "pickupContactEmail",
                                  label: "Pickup Contact Email",
                                },
                              },
                              [
                                _c("md-input", {
                                  attrs: { type: "email" },
                                  model: {
                                    value: _vm.orderDetails.pickupContact.email,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.orderDetails.pickupContact,
                                        "email",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "orderDetails.pickupContact.email",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "md-layout md-gutter" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-medium-size-50 md-small-size-100",
                          },
                          [
                            _c(
                              "form-group",
                              {
                                staticClass: "time-picker hide-clear-btn",
                                attrs: {
                                  name: "pickupTimeWindowStart",
                                  label: "Pickup Time Window Start",
                                },
                              },
                              [
                                _c("time-picker", {
                                  attrs: {
                                    time: _vm.pickupTimeWindowStart,
                                    "all-time-options": false,
                                    "is-required": false,
                                  },
                                  on: {
                                    selectedTime: _vm.getPickupTimeWindowStart,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-medium-size-50 md-small-size-100",
                          },
                          [
                            _c(
                              "form-group",
                              {
                                staticClass: "time-picker hide-clear-btn",
                                attrs: {
                                  name: "pickupTimeWindowEnd",
                                  label: "Pickup Time Window End",
                                },
                              },
                              [
                                _c("time-picker", {
                                  attrs: {
                                    time: _vm.pickupTimeWindowEnd,
                                    "all-time-options": false,
                                    "is-required": false,
                                  },
                                  on: {
                                    selectedTime: _vm.getPickupTimeWindowEnd,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("span", { staticClass: "timezone-note" }, [
                        _vm._v(
                          "Time window is displayed in the timezone of the pickup address."
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "md-card",
              [
                _c(
                  "md-card-header",
                  [
                    _c("h3", { staticClass: "md-title" }, [
                      _vm._v(
                        "\n                    Delivery Address\n                    "
                      ),
                      _c("span", { staticClass: "optional-label" }, [
                        _vm._v("(Optional)"),
                      ]),
                    ]),
                    _c(
                      "md-checkbox",
                      {
                        staticClass: "pickup-checkbox",
                        model: {
                          value: _vm.hasDeliveryAddress,
                          callback: function ($$v) {
                            _vm.hasDeliveryAddress = $$v
                          },
                          expression: "hasDeliveryAddress",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    Enable delivery address\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm.hasDeliveryAddress
                  ? _c("md-card-content", [
                      _c("div", { staticClass: "md-layout md-gutter" }, [
                        _c(
                          "div",
                          { staticClass: "md-layout-item" },
                          [
                            _c("google-autocomplete", {
                              attrs: {
                                label: "Delivery Address",
                                id: "shippingAddress",
                                classname: "form-control autocomplete-input",
                                placeholder: "",
                                "should-focus": false,
                              },
                              on: {
                                placechanged: _vm.handleShippingAddressChange,
                              },
                              model: {
                                value: _vm.orderDetails.shippingAddress,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderDetails,
                                    "shippingAddress",
                                    $$v
                                  )
                                },
                                expression: "orderDetails.shippingAddress",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "md-layout md-gutter" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-medium-size-33 md-small-size-100",
                          },
                          [
                            _c(
                              "form-group",
                              {
                                attrs: {
                                  name: "contactName",
                                  label: "Contact Name",
                                },
                              },
                              [
                                _c("md-input", {
                                  model: {
                                    value: _vm.orderDetails.contact.name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.orderDetails.contact,
                                        "name",
                                        $$v
                                      )
                                    },
                                    expression: "orderDetails.contact.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-medium-size-33 md-small-size-100",
                          },
                          [
                            _c(
                              "form-group",
                              {
                                attrs: {
                                  name: "contactPhone",
                                  label: "Contact Phone",
                                },
                              },
                              [
                                _c("md-input", {
                                  model: {
                                    value: _vm.orderDetails.contact.phone,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.orderDetails.contact,
                                        "phone",
                                        $$v
                                      )
                                    },
                                    expression: "orderDetails.contact.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-medium-size-33 md-small-size-100",
                          },
                          [
                            _c(
                              "form-group",
                              {
                                attrs: {
                                  name: "contactEmail",
                                  label: "Contact Email",
                                },
                              },
                              [
                                _c("md-input", {
                                  attrs: { type: "email" },
                                  model: {
                                    value: _vm.orderDetails.contact.email,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.orderDetails.contact,
                                        "email",
                                        $$v
                                      )
                                    },
                                    expression: "orderDetails.contact.email",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "md-layout md-gutter" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-medium-size-50 md-small-size-100",
                          },
                          [
                            _c(
                              "form-group",
                              {
                                staticClass: "time-picker hide-clear-btn",
                                attrs: {
                                  name: "timeWindowStart",
                                  label: "Delivery Time Window Start",
                                },
                              },
                              [
                                _c("time-picker", {
                                  attrs: {
                                    time: _vm.deliveryTimeWindowStart,
                                    "all-time-options": false,
                                    "is-required": false,
                                  },
                                  on: {
                                    selectedTime:
                                      _vm.getDeliveryTimeWindowStart,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-medium-size-50 md-small-size-100",
                          },
                          [
                            _c(
                              "form-group",
                              {
                                staticClass: "time-picker hide-clear-btn",
                                attrs: {
                                  name: "timeWindowEnd",
                                  label: "Delivery Time Window End",
                                },
                              },
                              [
                                _c("time-picker", {
                                  attrs: {
                                    time: _vm.deliveryTimeWindowEnd,
                                    "all-time-options": false,
                                    "is-required": false,
                                  },
                                  on: {
                                    selectedTime: _vm.getDeliveryTimeWindowEnd,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("span", { staticClass: "timezone-note" }, [
                        _vm._v(
                          "Time window is displayed in the timezone of the delivery address."
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "md-card",
              [
                _c("md-card-header", [
                  _c("h3", { staticClass: "md-title" }, [
                    _vm._v("Additional Details"),
                  ]),
                ]),
                _c(
                  "md-card-content",
                  [
                    _vm.loadFieldList !== null && _vm.loadFieldList.length > 0
                      ? _c(
                          "div",
                          { staticClass: "load-inputs-row" },
                          _vm._l(_vm.loadFieldList, function (load, index) {
                            return _c("load-inputs", {
                              key: index,
                              attrs: {
                                "load-definition": load,
                                "initial-value": _vm.loadValues,
                              },
                              on: { changed: _vm.handleLoadChanged },
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                    _vm.skillOptions.length
                      ? _c(
                          "form-group",
                          {
                            attrs: { name: "skills", label: "Required Skills" },
                          },
                          [
                            _c("multiselect", {
                              attrs: {
                                options: _vm.skillOptions,
                                multiple: true,
                                "close-on-select": true,
                                placeholder: "Pick required skills",
                              },
                              model: {
                                value: _vm.orderDetails.skills,
                                callback: function ($$v) {
                                  _vm.$set(_vm.orderDetails, "skills", $$v)
                                },
                                expression: "orderDetails.skills",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "form-group",
                      {
                        attrs: {
                          name: "deliveryInstructions",
                          label: "Delivery Instructions",
                        },
                      },
                      [
                        _c("md-textarea", {
                          model: {
                            value: _vm.orderDetails.deliveryInstructions,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.orderDetails,
                                "deliveryInstructions",
                                $$v
                              )
                            },
                            expression: "orderDetails.deliveryInstructions",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "form-group",
                      { attrs: { name: "notes", label: "Notes" } },
                      [
                        _c("md-textarea", {
                          model: {
                            value: _vm.orderDetails.notes,
                            callback: function ($$v) {
                              _vm.$set(_vm.orderDetails, "notes", $$v)
                            },
                            expression: "orderDetails.notes",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "md-card",
              [
                _c(
                  "md-card-header",
                  [
                    _c("h3", { staticClass: "md-title" }, [_vm._v("Items")]),
                    _c(
                      "md-button",
                      {
                        staticClass: "md-primary md-just-icon md-round",
                        on: { click: _vm.addItem },
                      },
                      [_c("md-icon", [_vm._v("add")])],
                      1
                    ),
                  ],
                  1
                ),
                _c("md-card-content", [
                  _vm.orderDetails.items.length === 0
                    ? _c("div", { staticClass: "no-items" }, [
                        _c("p", [
                          _vm._v(
                            "No items added yet. Click the + button to add an item."
                          ),
                        ]),
                      ])
                    : _c(
                        "div",
                        { staticClass: "items-list" },
                        _vm._l(_vm.orderDetails.items, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "item-entry" },
                            [
                              _c("div", { staticClass: "item-header" }, [
                                _c("span", { staticClass: "item-number" }, [
                                  _vm._v(
                                    "\n                                Item " +
                                      _vm._s(index + 1) +
                                      "\n                                "
                                  ),
                                  item.status
                                    ? _c(
                                        "span",
                                        { staticClass: "item-status-badge" },
                                        [_vm._v(_vm._s(item.status))]
                                      )
                                    : _vm._e(),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "item-actions" },
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass: "md-icon-button md-dense",
                                        attrs: { title: "Duplicate item" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.duplicateItem(index)
                                          },
                                        },
                                      },
                                      [_c("md-icon", [_vm._v("content_copy")])],
                                      1
                                    ),
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-icon-button md-dense md-danger",
                                        attrs: {
                                          disabled:
                                            item.itemId &&
                                            item.status &&
                                            item.status !== "Created",
                                          title:
                                            item.itemId &&
                                            item.status &&
                                            item.status !== "Created"
                                              ? "Cannot remove: item status is " +
                                                item.status
                                              : "Delete item",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeItem(index)
                                          },
                                        },
                                      },
                                      [_c("md-icon", [_vm._v("delete")])],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "md-layout md-gutter" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-medium-size-50 md-small-size-100",
                                    },
                                    [
                                      _c(
                                        "form-group",
                                        {
                                          attrs: {
                                            name: "barcode",
                                            label: "Barcode",
                                          },
                                        },
                                        [
                                          _c("md-input", {
                                            model: {
                                              value: item.barcode,
                                              callback: function ($$v) {
                                                _vm.$set(item, "barcode", $$v)
                                              },
                                              expression: "item.barcode",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-medium-size-50 md-small-size-100",
                                    },
                                    [
                                      _c(
                                        "form-group",
                                        {
                                          attrs: { name: "sku", label: "SKU" },
                                        },
                                        [
                                          _c("md-input", {
                                            model: {
                                              value: item.sku,
                                              callback: function ($$v) {
                                                _vm.$set(item, "sku", $$v)
                                              },
                                              expression: "item.sku",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "md-layout md-gutter" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "md-layout-item md-size-100",
                                    },
                                    [
                                      _c(
                                        "form-group",
                                        {
                                          attrs: {
                                            name: "description",
                                            label: "Description",
                                          },
                                        },
                                        [
                                          _c("md-input", {
                                            model: {
                                              value: item.description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression: "item.description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm.itemDimensionFields &&
                              _vm.itemDimensionFields.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "item-dimensions" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "dimensions-header" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "dimensions-label" },
                                            [_vm._v("Dimensions")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "dimensions-inputs" },
                                        _vm._l(
                                          _vm.itemDimensionFields,
                                          function (loadDef) {
                                            return _c(
                                              "div",
                                              {
                                                key: loadDef.type,
                                                staticClass: "load-vals",
                                              },
                                              [
                                                _c(
                                                  "form-group",
                                                  {
                                                    attrs: {
                                                      name: loadDef.type,
                                                      label: loadDef.label,
                                                    },
                                                  },
                                                  [
                                                    _c("md-input", {
                                                      attrs: {
                                                        type: "number",
                                                        step: "0.01",
                                                        min: "0",
                                                      },
                                                      model: {
                                                        value:
                                                          item.load[
                                                            loadDef.type
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item.load,
                                                            loadDef.type,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.load[loadDef.type]",
                                                      },
                                                    }),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(loadDef.symbol)
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", [
          _c(
            "div",
            { staticClass: "summary" },
            [
              _c(
                "md-card",
                [
                  _c("md-card-header", [
                    _c("h3", { staticClass: "md-title" }, [_vm._v("Summary")]),
                  ]),
                  _c("md-card-content", [
                    _vm.orderDetails.orderNumber
                      ? _c("div", { staticClass: "summary-section" }, [
                          _c("h6", [_vm._v("Order Number")]),
                          _c("p", [
                            _vm._v(_vm._s(_vm.orderDetails.orderNumber)),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.orderDetails.status
                      ? _c("div", { staticClass: "summary-section" }, [
                          _c("h6", [_vm._v("Status")]),
                          _c("p", [_vm._v(_vm._s(_vm.orderDetails.status))]),
                        ])
                      : _vm._e(),
                    _vm.orderDetails.orderDate
                      ? _c("div", { staticClass: "summary-section" }, [
                          _c("h6", [_vm._v("Order Date")]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.formatDisplayDate(
                                  _vm.orderDetails.orderDate
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.orderDetails.expectedDeliveryDate
                      ? _c("div", { staticClass: "summary-section" }, [
                          _c("h6", [_vm._v("Expected Delivery")]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.formatDisplayDate(
                                  _vm.orderDetails.expectedDeliveryDate
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.hasDeliveryAddress &&
                    _vm.orderDetails.shippingAddress &&
                    _vm.orderDetails.shippingAddress.address
                      ? _c("div", { staticClass: "summary-section" }, [
                          _c("h6", [_vm._v("Delivery Address")]),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.orderDetails.shippingAddress.address)
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.hasPickupAddress &&
                    _vm.orderDetails.pickupAddress &&
                    _vm.orderDetails.pickupAddress.address
                      ? _c("div", { staticClass: "summary-section" }, [
                          _c("h6", [_vm._v("Pickup Address")]),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.orderDetails.pickupAddress.address)
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.orderDetails.items && _vm.orderDetails.items.length > 0
                      ? _c("div", { staticClass: "summary-section" }, [
                          _c("h6", [_vm._v("Items")]),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.orderDetails.items.length) + " item(s)"
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "md-card-actions",
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          attrs: { disabled: _vm.isUpdating },
                          on: { click: _vm.updateOrder },
                        },
                        [
                          _vm.isUpdating
                            ? _c("md-progress-spinner", {
                                attrs: {
                                  "md-diameter": 20,
                                  "md-stroke": 2,
                                  "md-mode": "indeterminate",
                                },
                              })
                            : _c("span", [_vm._v("Update Order")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ])
    : _c(
        "div",
        { staticClass: "loader-container" },
        [
          _c("fade-loader", { attrs: { loading: true, color: "#333333" } }),
          _c("span", [_vm._v("LOADING")]),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }